import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor() { }

  public response = {
    message: '',
    type:''
  };
  private emitChangeSource = new BehaviorSubject<any>(this.response);
  changeEmitted$ = this.emitChangeSource.asObservable();

  emitChange(message, type) {
    let x = {message:null, type: null};
    x.message = message;
    x.type = type;
    this.emitChangeSource.next(x);
  }
}
